import { Component, OnInit } from '@angular/core';
import { Utils } from '../../tools/utils';
import { Roles, IxellAPIService, OrderLight } from '../../tools/api.service';
import { StorageService } from '../../tools/storage.service';
import { HeaderService } from '../../tools/header.service';
import { ErrorService } from '../../tools/error.service';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Constants } from '../../entities/Constants';
import { RentingInfo } from '../../models/rentinginfo';

@Component({
  selector: 'app-rentinglist',
  templateUrl: './rentinglist.component.html',
  styleUrls: ['./rentinglist.component.scss']
})
export class RentinglistComponent implements OnInit {

  rentingSub: any;
  rentingInfoSub: any;

  rentingInfo: RentingInfo[] = [];
  allRenting: RentingInfo[] = [];
  rentingLst: RentingInfo[] = [];
  dataInfo: any[] = [];
  displayedColumns = ["rentingId", "status", "rentingDate", "treatmentDate", "companySocialReason", "info"];

  orderLight: OrderLight[];
  totalAmountOrder: number;
  isSupport: boolean = false;

  constructor(private storage: StorageService, private api: IxellAPIService, private headerService: HeaderService, private errorService: ErrorService) { }

  ngOnInit() {
    Utils.deleteStorageData();
    // Vérification si l'utilisateur est ctcf 
    if (Number.parseInt(this.storage.get("role")) & Roles.CTC) {
      this.rentingSub = this.api.ctcRenting().subscribe(data => {
        // Affichage de toutes les demandes de location
        data.forEach(element => {
          this.allRenting.push(RentingInfo.parseToRentingInfo(element));
          this.rentingLst = this.allRenting.slice();
        })
      }, error => {
        if (this.rentingSub != null) this.rentingSub.unsubscribe();
        this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "ctcRenting", new Date().toString());
        console.log(error);
      });
      // Flèche de retour navbar
      this.headerService.changeCanBack(true);
      this.headerService.changeTitle("IxellWebLab");
      this.headerService.changeLogo(null);
    }
  }

  ngOnDestroy() {
    if (this.rentingSub != null) this.rentingSub.unsubscribe();
    if (this.rentingInfoSub != null) this.rentingInfoSub.unsubscribe();

  }

  // Affichage des infos dans la modale Plus d'informations
  displayInfoRenting(rentingID: number) {
    let language = this.storage.get("actualLanguage");
    this.rentingInfoSub = this.api.selectRentingInfo(rentingID).subscribe(data => {
      if (data) {
        this.dataInfo = [];
        this.dataInfo = data;
        let modal = document.getElementById('infos');
        modal.style.display = 'block';
      }
    }, error => {
      this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "infoRenting, rentingID = " + rentingID, new Date().toString());
      console.log(error);
      if (this.rentingInfoSub != null) this.rentingInfoSub.unsubscribe();
    });

    this.orderLight = [];
    this.totalAmountOrder = 0;
    this.api.selectOrderLightById(rentingID, language).subscribe(data => {
      let nbSupport = 0;
      this.orderLight = data;
      this.orderLight.forEach(el => this.totalAmountOrder += (el.amountP * el.qty))
      this.orderLight.forEach(function (el) {
        if (el.typeP == 2)
        { nbSupport ++ } 
      })
      if (nbSupport > 0) this.isSupport = true;
      else this.isSupport = false;
    }, error => {
      console.log(error);
    })
  }

  closeModal(name: string) {
    switch (name) {
      case "infos":
        let infosModal = document.getElementById("infos");
        infosModal.style.display = "none";
        break;      
    }
  }

  sortScale(sort: Sort, status: string) {
    var data = this.rentingLst;
    Constants.sortScale(sort, status, data);
    this.rentingLst = data.slice();
  }
}
